import { SwapStepNum } from '@/containers/home/confirm/SwapStepper'
import i18n from '@/i18n'

export const TradeStepMessages: Record<SwapStepNum, string> = {
  [SwapStepNum.INIT]: i18n.t('step.CONFIRM'),
  [SwapStepNum.CLAIM_OWNERSHIP]: i18n.t('step.CLAIM_OWNERSHIP'),
  [SwapStepNum.APPROVE]: i18n.t('step.APPROVE'),
  [SwapStepNum.WAITING_TX]: i18n.t('step.WAITING_TX'),
  [SwapStepNum.SUBMITTING]: i18n.t('step.SUBMITTING'),
}

export const DEFAULT_AMOUNT_IN = '1' // to show preview quote
export const WALLET_CONNECT_SOURCE = 'HOME'
export const BIPS = 0.0001

export const IS_DEBUG = !!new URLSearchParams(window.location.search).get('debug')
export const IS_TRADE_TIMEOUT = !!new URLSearchParams(window.location.search).get('timeout')
export const IS_ACROSS_EVM_REFUND = !!new URLSearchParams(window.location.search).get('acrossEvmRefund')
export const IS_ACROSS_BTC_REFUND = !!new URLSearchParams(window.location.search).get('acrossBtcRefund')
export const IS_MOCK_ACROSS_DEPOSIT = !!new URLSearchParams(window.location.search).get('mockAcrossDeposit')

export const SWAP_FORM_ID = 'swap-form'
